module.exports = __webpack_public_path__ + "img/point-w.36e100b6.png";